import React, { useEffect, useRef } from "react";
import * as skin3d from 'skin3d';

// --- Link della skin da imgur (Deve finire con .png) ---
const SKIN_URL = "https://i.imgur.com/rMeoExw.png"; 
// -----------------------------------------------------------

function SkinViewer() {
  const canvasRef = useRef(null);
  const viewerRef = useRef(null);

  useEffect(() => {
    // Evita duplicazioni
    if (viewerRef.current || !canvasRef.current) return;

    // Inizializzazione Viewer
    const viewer = new skin3d.View({
      canvas: canvasRef.current,
      width: 400,
      height: 500,
      skin: SKIN_URL
    });

    // Configurazione Modello Slim
    viewer.loadSkin(SKIN_URL, { model: "slim" });

    // Sfondo e Name Tag 
    viewer.background = null; 
    viewer.nameTag = "ImMaster__"; 

    // Configurazione Luci
    viewer.globalLight.intensity = 3.0; 
    viewer.cameraLight.intensity = 0.6; 

    // Configurazione Camera
    viewer.fov = 70; 
    viewer.zoom = 0.8; 

    // Animazione Camminata
    viewer.animation = new skin3d.WalkingAnimation(); 
    viewer.animation.speed = 1.0; 
    viewer.animation.paused = false;

    // Controlli Mouse disattivati
    viewer.controls.enableRotate = false;
    viewer.controls.enableZoom = false;
    viewer.controls.enablePan = false;

    viewerRef.current = viewer;

    return () => {
      // Pulizia quando si cambia pagina (importante per non bloccare il browser)
      // Nota: questo ferma l'animazione SOLO se l'utente chiude la pagina o il componente
      if (viewer.animation) {
         viewer.animation = null;
      }
      viewer.dispose(); // Liberazione della memoria
    };
  }, []);

  return (
    <canvas 
      ref={canvasRef} 
      style={{ 
        width: "100%", 
        height: "auto", 
        maxHeight: "500px",
        display: "block",
        margin: "0 auto",
        marginLeft: "-60px"
      }} 
    />
  );
}

export default SkinViewer;